import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    EventExtra7: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    notes: {
      validations: []
    },
    Website: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options:[
              {label: 'Wedding' , value: 'Wedding'},
              {label: 'Corporate Event' , value: 'Corporate Event'},
              {label: 'Party/Other' , value: 'Party/Other'},
              {label: 'School' , value: 'School'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date - First Preference:*',
            mapping: 'eventDate'
          },
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date - Second Preference:',
            mapping: 'EventExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Estimated Budget:*',
            options: [
              { label: 'Under $10,000', value: 'Under $10,000' },
              { label: '$10,001 - $20,000', value: '$10,001 - $20,000' },
              { label: '$20,001 - $30,000', value: '$20,001 - $30,000' },
              { label: '$30,001 - $40,000', value: '$30,001 - $40,000' },
              { label: '$40,001 - $50,000', value: '$40,001 - $50,000' },
              { label: '$50,000+', value: '$50,000+' }
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:*',
            options: [
              { label: 'Attended an Event', value: 'Attended an Event' },
              { label: 'Bride Online', value: 'Bride Online' },
              { label: 'Easy Wedding', value: 'Easy Wedding' },
              { label: 'Family or Friend', value: 'Family or Friend' },
              { label: 'Google Search', value: 'Google Search' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Other (please specify below)', value: 'Other (please specify below)' },
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Notes:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Stables at Sages Cottage Contact Form',
    formId: '2077',
    clientKey: '35D2935E-F31C-4AC4-992F-A8FCF4A5D6D4',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://thestablesatsages.com.au/thank-you-for-getting-in-touch/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
